function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowCircleRight as falArrowCircleRight, faEnvelope as falEnvelope, faBook as falBook } from '@epi/font-awesome-pro/js-packages/@fortawesome/pro-light-svg-icons';

import { faCookieBite as fasCookieBite, faGlobe as fasGlobe, faFile as fasFile, faPuzzlePiece as fasPuzzlePiece, faServer as fasServer, faPlay as fasPlay, faExchange as fasExchange, faCalculator as fasCalculator, faWrench as fasWrench } from '@epi/font-awesome-pro/js-packages/@fortawesome/pro-solid-svg-icons';

import { faTwitter, faFacebook, faInstagram } from '@epi/font-awesome-pro/js-packages/@fortawesome/pro-brands-svg-icons';

import IconBase from './IconBase';

import './Icon.css';

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Icon.prototype.componentDidMount = function componentDidMount() {};

  Icon.prototype.getClassName = function getClassName() {
    if (this.props.className) {
      return 'Icon ' + this.props.className;
    }
    return 'Icon';
  };

  Icon.prototype.render = function render() {
    return React.createElement(
      'span',
      { className: this.getClassName() },
      React.createElement(IconBase, this.props)
    );
  };

  return Icon;
}(Component);

Icon.init = function () {
  if (Icon.initialised) {
    return;
  }

  library.add(falArrowCircleRight, falEnvelope, falBook, fasCookieBite, fasGlobe, fasFile, fasPuzzlePiece, fasServer, fasPlay, fasExchange, fasCalculator, fasWrench, faTwitter, faFacebook, faInstagram);

  Icon.initialised = true;
};

Icon.init();

export default Icon;